import { render } from "./product-description-sidebar.vue?vue&type=template&id=1cec7c7e"
import script from "./product-description-sidebar.vue?vue&type=script&lang=js"
export * from "./product-description-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__